import httpService from './httpService';
import { subscribeUrl, unSubscribeUrl, subscriptionDetailUrl } from '../constants/apiEndPoints';

export function subscribeAPI(email) {
    const data = { email };
    return httpService.post(subscribeUrl, data);
}

export function unsubscribeAPI(data) {
    const {
        email, fatwas, news, uuid,
    } = data;

    const payload = {
        email,
        fatwas,
        news,
    };
    return httpService.put(unSubscribeUrl(uuid), payload);
}

export function getSubscribeDetailAPI(uuid) {
    return httpService.get(subscriptionDetailUrl(uuid));
}
